import { render, staticRenderFns } from "./hizliOde.vue?vue&type=template&id=7c08ca1f&scoped=true&"
import script from "./hizliOde.vue?vue&type=script&lang=js&"
export * from "./hizliOde.vue?vue&type=script&lang=js&"
import style0 from "./hizliOde.vue?vue&type=style&index=0&id=7c08ca1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c08ca1f",
  null
  
)

export default component.exports